import React, { useState, useEffect } from "react";
import editIcon from "../../assets/images/budget/dropdown.png";
import { DebtReport } from "./components/DebtReport";
import { DebtChart } from "./components/DebtChart";
import { DebtList } from "./components/DebtList";
import { useHistory } from "react-router-dom";
import { Menu, Dropdown } from "antd";
import FETCH from "../../utils/fetch";
import swal from "sweetalert";
import { MODULE_API } from "../../apis";
import "./style/debtStyle.css";
import { generateAmortizationData } from "../../helpers/amortizationCalcultion";
import ModalVideo from "../ModuleVideos/ModalVideo";
export const DebtDashboardMain = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [amortizationLoading, setAmortizationLoading] = useState(false);
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [categoryBalance, setCategoryBalance] = useState(null);
  const [selectedPriority, setSelectedPriority] = useState(null);
  const [amortizationData, setAmortizationData] = useState(null);
  const [amortizationDataWithSnowball, setAmortizationDataWithSnowball] =
    useState(null);

  const [extraAmount, setExtraAmount] = useState(0);

  const getLiabilitesList = async () => {
    try {
      setLoading(true);
      const userRole =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role"));
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Liabilities and Credit&page=1&limit=50&clientId=${ID}`
            : `?module=Liabilities and Credit&page=1&limit=50`,
        body: {},
      });
      setLoading(false);
      if (datares && datares.records) {
        datares.records.map((item) => {
          if (item.subType == "Credit") {
            item["Nickname of Liabilities"] = item["Nickname of Credit"];
            item["Initial Loan Amount"] = item["Credit Balance"];
            item["Interest Rate"] = item["Interest Rate (or APR%)"];
            item["Maturity Date"] = item["Point Expiration"];
            item["Name of Financial Institution"] = item["Name of Issuer"];
            item["Monthly Payment"] =
              item["Monthly Payment"] && item["Monthly Payment"].toString();
            item["Start Date"] = new Date();
            item["subType"] = item.subType;
          }
        });
        setLiabilitesCredit(datares.records);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getLoanbyCategory = async () => {
    try {
      setLoading(true);
      let datares = await MODULE_API.fetchCategoryWiseLoanBalance(
        "Liabilities and Credit"
      );

      if (datares && datares.values) {
        setCategoryBalance(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getDebtPayOff = async () => {
    try {
      setLoading(true);
      let datares = await MODULE_API.getPayOffData();

      if (datares && datares.data && datares.data.rows) {
        if (datares.data.rows[0]) {
          setSelectedPriority(datares.data.rows[0].strategy);
          setExtraAmount(datares.data.rows[0].snowball);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getAll = async () => {
    setAmortizationLoading(true);
    await getLiabilitesList();
    await getDebtPayOff();
    setAmortizationLoading(false);
  };

  const enableLiablityForDebtPayoff = async (moduleId, debt_calculation_enable) => {
    try {
      setLoading(true);
      const payload = {
        debt_calculation_enable: debt_calculation_enable,
      };
      const res = await MODULE_API.updateClientModule(moduleId, {
        ...payload,
      });

      setLoading(false);
      if (res && res.status === 200) {
        swal({
          title: "Success",
          text: "Module enabled/disabled for Debt Payoff successfully",
          icon: "success",
        });
        getAll();
      }
      if (res && res.status === 400) {
        if (res.message) {
          swal({
            title: "Error",
            text: res.message,
            icon: "error",
            buttons: true,
            dangerMode: true,
          });
        }
        return;
      }
    } catch (error) {
      setLoading(false);
      swal({
        title: "Error",
        text: "Error while updating Module",
        icon: "error",
        buttons: true,
        dangerMode: true,
      });
    }
  };
  useEffect(() => {
    getAll();
    getLoanbyCategory();
  }, []);
  useEffect(() => {
    const fetchAmortizationData = async () => {
      if (liabilitiesCredit) {
        // setAmortizationLoading(true);
        try {
          // Simulate async so UI shows skeleton
          await new Promise((resolve) => setTimeout(resolve, 300));
          const filteredLiabilities = liabilitiesCredit.filter(item => !item.debt_calculation_enable);

          const allAmortizationData = generateAmortizationData({
            liabilitiesData: filteredLiabilities,
            selectedPriority: selectedPriority || "",
          });
          const allAmortizationDataSnowBall = generateAmortizationData({
            liabilitiesData: filteredLiabilities,
            selectedPriority: selectedPriority || "",
            snowball: extraAmount,
          });
          // console.log("allAmortizationDataSnowBall",allAmortizationDataSnowBall,allAmortizationData,extraAmount)

          setAmortizationData(allAmortizationData);
          setAmortizationDataWithSnowball(allAmortizationDataSnowBall);
        } catch (error) {
          console.error("Error generating amortization data:", error);
        } finally {
          // setAmortizationLoading(false);
        }
      }
    };

    fetchAmortizationData();
  }, [selectedPriority, liabilitiesCredit, extraAmount]);

  return (
    <div className="debt-main">
      <ModalVideo module="Debt Payoff" autoOpen={true} />
      <div className="debt-create">
        <div className="add-debt-section" style={{ width: "100%" }}>
          <div className="addTitle">
            Debt Payoff
            <span style={{ marginLeft: "10px" }}>
              <Dropdown
                trigger={["click"]}
                overlay={
                  <Menu>
                    <Menu.Item>
                      <div
                        onClick={() => {
                          history.push("/debt-payOff/strategy");
                        }}
                      >
                        Strategy
                      </div>
                    </Menu.Item>
                  </Menu>
                }
              >
                <a
                  className="ant-dropdown-link"
                  onClick={(e) => e.preventDefault()}
                >
                  <img src={editIcon} height={12} width={18} alt="icon"></img>
                </a>
              </Dropdown>
            </span>
          </div>
          <button
            className="addbuttonassets"
            onClick={() => {
              history.push("/liabilities_credit_new");
            }}
          >
            {" "}
            + Add Liability
          </button>
        </div>
      </div>
      <DebtReport
        strategy={selectedPriority && selectedPriority}
        amortizationData={amortizationData && amortizationData}
        categoryBalance={categoryBalance && categoryBalance}
        loading={amortizationLoading}
      />
      <DebtChart
        amortizationData={amortizationData && amortizationData}
        amortizationDataWithSnowball={
          amortizationDataWithSnowball && amortizationDataWithSnowball
        }
        loading={amortizationLoading}
      />
      <DebtList
        liabilitiesCredit={liabilitiesCredit && liabilitiesCredit}
        amortizationData={amortizationData && amortizationData}
        enableLiablityForDebtPayoff={enableLiablityForDebtPayoff}
        loading={loading}
      />
    </div>
  );
};
